import { Injectable } from '@angular/core';
import { environment } from '@env';
import { HttpClient } from '@angular/common/http';
import { ResourceService } from '@app/http/resource/resource.service';
import { LoginField } from '../login-fields';
import { LoginFieldsSerializer } from '../login-fields.serializer';

@Injectable({
  providedIn: 'root'
})
export class LoginFieldsPortalService extends ResourceService<LoginField>  {
  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      `${environment.API}`,
      `portal/login-fields`,
      new LoginFieldsSerializer());
  }
}
